"use strict";
exports.__esModule = true;
exports.DONE = exports.OPENED = exports.UNSENT = void 0;
exports.UNSENT = 0; //	Client has been created. open() not called yet.
exports.OPENED = 1; //	open() has been called.
// export const HEADERS_RECEIVED = 2; //	send() has been called, and headers and status are available.
// export const LOADING = 3; //	Downloading; responseText holds partial data.
exports.DONE = 4; //	The operation is complete.
//# sourceMappingURL=readyState.js.map